import script from "./TaskRenderer.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskRenderer.vue?vue&type=script&setup=true&lang=js"

import "./TaskRenderer.vue?vue&type=style&index=0&id=6943b0a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6943b0a0"]])

export default __exports__